import { get, upload, post } from '@api/request';

export const fetchDocumentUploads = async (
  { assessmentService },
  authenticationToken,
) => {
  const url = `${assessmentService}/certification/taxingunitdocumentuploads`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchDocumentUploadErrors = async (
  { assessmentService },
  authenticationToken,
  { runID },
) => {
  const url = `${assessmentService}/certification/taxingunitdocumentupload/${runID}/errors`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const uploadDocument = async (
  { assessmentService },
  authenticationToken,
  { payload },
) => {
  const url = `${assessmentService}/certification/taxingunitdocumentuploads/uploadfile`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const documentUploadStartRun = async (
  { assessmentService },
  authenticationToken,
  { payload },
) => {
  const url = `${assessmentService}/certification/taxingunitdocumentuploads`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};
